import {useEffect, useRef} from 'react'
import {PartyEditModalHeader} from './PartyAddEditHeader'
import {PartyEditModalFormWrapper} from './PartyAddEditFormWrapper'
import {useListView} from '../core/ListViewProvider'

const PartyEditModal = ({isPage}: {isPage?: boolean}) => {
  const modalRef = useRef<any>()
  const {setItemIdForUpdate} = useListView()

  //console.log("partyAddEditFormWrapper --> ",)
  useEffect(() => {
    const checkIfClickedOutside = (e: any) => {
      if (modalRef.current && !modalRef.current.contains(e.target) && e.target.tagName !== 'HTML') {
        setItemIdForUpdate(undefined)
      }
    }

    return () => {}
  })

  useEffect(() => {
    if (!isPage) {
      document.body.classList.add('modal-open')
      return () => {
        document.body.classList.remove('modal-open')
      }
    }
  }, [isPage])


  useEffect(() => {
    const checkIfClickedOutside = (e: any) => {
      if (modalRef.current && !modalRef.current.contains(e.target) && e.target.tagName !== 'HTML') {
        setItemIdForUpdate(undefined)
      }
    }

    return () => {}
  }, [])

  return (
    <>
      {isPage ? (
        <div className='card'>
          <div className='card-header'>
            <PartyEditModalHeader isPage />
          </div>
          <div className='card-body'>
            <PartyEditModalFormWrapper />
          </div>
        </div>
      ) : (
        <>
          <div
            className='modal fade show d-block'
            id='kt_modal_add_Party'
            role='dialog'
            tabIndex={-1}
            aria-modal='true'
            data-backdrop='static'
          >
            <div className='modal-dialog mw-900px' ref={modalRef}>
              <div className='modal-content'>
                <PartyEditModalHeader />
                <div className='modal-body mt-5 scroll-y p-0 px-10'>
                  <PartyEditModalFormWrapper />
                </div>
              </div>
            </div>
          </div>
          {/* begin::Modal Backdrop */}
          <div className='modal-backdrop fade show'></div>
          {/* end::Modal Backdrop */}
        </>
      )}
    </>
  )
}

export {PartyEditModal}
